/**
 * Add a few basic routes to ui-router for our components
 */
import wpConfig from 'appJs';

// these query params encapsulate application state
const queryParams = [
  'state',
  'dataView',
  'activeTab',
  'currentTimeframe',
  'startTimeframe',
  'selectedDistributions',
  'override_key',
  'print',
  '{selectedRows:json}',
  '{sortModel:json}',
];

export default function() {
  RouterConfig.$inject = ['$stateProvider'];
  function RouterConfig($stateProvider) {
    $stateProvider
      // Abstract state lets us use query params in the application without
      // reloading components
      .state('datacenter', {
        abstract: true,
        url: `${wpConfig.base}`,
      })
      .state('datacenter.main', {
        views: {
          '@': {
            template: '<datacenter-wrapper></datacenter-wrapper>',
          },
        },
        url: `?${queryParams.join('&')}`,
        reloadOnSearch: false,
      });
  }
  return RouterConfig;
}



// WEBPACK FOOTER //
// ../~/eslint-loader!./js/config/routeConfig.js